import React, { FC } from "react";
import { motion } from "framer-motion";

interface FullScreenProps {
  medias: {
    id: number;
    description: string;
    imgUrl: string;
    videoUrl?: string;
  }[];
  initSlideIndex: number;
  closeModal: () => void;
}

const FullScreen: FC<FullScreenProps> = ({
  medias,
  initSlideIndex,
  closeModal,
}) => {
  return (
    <motion.div
      className="fixed inset-0 bg-black bg-opacity-90 flex justify-center items-center z-50 p-4"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      onClick={closeModal}
    >
      <div
        className="absolute top-5 right-5 text-white text-3xl cursor-pointer bg-gray-800 px-3 py-2 rounded-full"
        onClick={closeModal}
      >
        ✖
      </div>
      {medias[initSlideIndex].videoUrl ? (
        <iframe
          className="w-[90vw] h-[90vh] rounded-lg"
          src={`https://player.vimeo.com/video/${getVimeoId(
            medias[initSlideIndex].videoUrl || ""
          )}?autoplay=1&muted=0`}
          frameBorder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
          title="Vimeo Video"
        />
      ) : (
        <img
          src={medias[initSlideIndex].imgUrl}
          className="max-w-[90vw] max-h-[90vh] object-contain rounded-lg"
          alt={medias[initSlideIndex].description}
        />
      )}
    </motion.div>
  );
};

const getVimeoId = (url: string): string => {
  const match = url.match(/vimeo\.com\/(\d+)(?:\/([\w\d]+))?/);
  return match ? `${match[1]}${match[2] ? `/${match[2]}` : ""}` : "";
};

export default FullScreen;
